import HttpUtils from "../utils/HttpUtils";

/**
 * 记录访问量（对接后端 /web/access/record）
 * @param {string} projectCode 项目编码
 * @param {string} projectName 项目名称
 * @param {string} accessPath 访问路径
 */
const  recordAccess = ( accessPath: string) => {
  // 默认值
  const DEFAULT_PROJECT_CODE = 'qzkt_web'       // 默认项目编码
  const DEFAULT_PROJECT_NAME = 'study.ooowin.com'         // 默认项目名称
  return HttpUtils.post("/web/access-statistics/record", {
    projectCode: DEFAULT_PROJECT_CODE,
    projectName: DEFAULT_PROJECT_NAME,
    accessPath: accessPath || window.location.pathname,
  })
}

// 获取当前用户IP地址（对接后端 /web/ipUtils/getIpAddr)
const getRealIpAdrr = () => {
  return HttpUtils.get("/web/ipUtils/getIpAddr")
} 


// 根据经纬度获取城市
const getCityByLngLat = (lng: number, lat: number) => {
  return HttpUtils.get(`/web/geo/query?longitude=${lng}&latitude=${lat}`)}

// 根据ip获取城市位置
const getCityByIp = (ip: string) => { 
  return HttpUtils.get(`/web/geo/queryByIp?ip=${ip}`)  
} 

const CommonService = {
  recordAccess,
  getRealIpAdrr,
  getCityByLngLat,
  getCityByIp
}

export default CommonService;